// src/api/subscriptionApi.js
import axiosConfig from './axiosConfig';

export const subscriptionApi = {
    getCurrent: async () => {
        const response = await axiosConfig.get('/subscriptions/current');
        return response.data;
    },

    // Avvia upgrade con provider, telefono e ciclo di fatturazione
    upgradeToPro: async ({ plan = 'PRO', billingCycle = 'monthly', provider, phone } = {}) => {
        const response = await axiosConfig.post('/subscriptions/upgrade', {
            plan,
            billingCycle,
            ...(provider && { provider }),
            ...(phone    && { phone }),
        });
        return response.data;
    },

    cancel: async () => {
        const response = await axiosConfig.post('/subscriptions/cancel');
        return response.data;
    },

    getInvoices: async () => {
        const response = await axiosConfig.get('/subscriptions/invoices');
        return response.data;
    },

    getPaymentHistory: async () => {
        const response = await axiosConfig.get('/subscriptions/payments');
        return response.data;
    },
};